import { useRef, useEffect, useCallback, MouseEvent as ReactMouseEvent } from 'react'

const useDragScroll = () => {
  const ref = useRef<HTMLDivElement>(null)
  const isDragging = useRef(false)
  const startX = useRef(0)
  const scrollLeftStart = useRef(0)

  const onMouseDown = useCallback((e: ReactMouseEvent<HTMLDivElement>) => {
    const el = ref.current
    if (!el) return
    isDragging.current = true
    startX.current = e.clientX
    scrollLeftStart.current = el.scrollLeft
    el.style.cursor = 'grabbing'
    el.style.scrollBehavior = 'auto'
    document.body.style.userSelect = 'none'
    e.preventDefault()
  }, [])

  useEffect(() => {
    const onMouseMove = (e: globalThis.MouseEvent) => {
      if (!isDragging.current) return
      const el = ref.current
      if (!el) return
      e.preventDefault()
      const walk = e.clientX - startX.current
      el.scrollLeft = scrollLeftStart.current - walk
    }

    const onMouseUp = () => {
      if (!isDragging.current) return
      isDragging.current = false
      const el = ref.current
      if (el) {
        el.style.cursor = 'grab'
        el.style.scrollBehavior = ''
      }
      document.body.style.userSelect = ''
    }

    document.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseup', onMouseUp)

    return () => {
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
    }
  }, [])

  return { ref, onMouseDown }
}

export default useDragScroll
